import analytics, { ANALYTICS_EVENTS } from '@/services/analytics'

export function useAnalytics() {
  return {
    track: analytics.track.bind(analytics),
    identify: analytics.identify.bind(analytics),
    setUserProfile: analytics.setUserProfile.bind(analytics),
    registerSuperProperties: analytics.registerSuperProperties.bind(analytics),
    unregisterSuperProperty: analytics.unregisterSuperProperty.bind(analytics),
    reset: analytics.reset.bind(analytics),
    trackPageView: analytics.trackPageView.bind(analytics),
    ANALYTICS_EVENTS,
  }
}
